import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../../../src/helpers/reselectHelpers';
import {CardGroupModel} from '../../../../../../../src/models/api/cardGroupModel';
import {CardModel} from '../../../../../../../src/models/api/cardModel';
import {contactsManagerTableAddOtherCardsToGroupsAsyncAction} from '../../../../../../../src/store/panels/contacts/contactsManager/table/contactsManagerTableActions';
import {ContactsManagerPanelId} from '../../../../../../../src/store/panels/panelStateBase';
import {OtherCardNamespaceConfirmationDialog} from './otherCardNamespaceConfirmationDialog';

/*
 * Props.
 */

interface OtherCardNamespaceConfirmationDialogContainerProps {
  panelId: ContactsManagerPanelId;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<OtherCardNamespaceConfirmationDialogContainerProps>()(
  ({panelId}) => ({
    onAddOtherCardsToGroupsAsync: (
      cardGroups: ReadonlyArray<CardGroupModel>,
      cards: ReadonlyArray<CardModel>,
      namespace: string,
    ) => contactsManagerTableAddOtherCardsToGroupsAsyncAction(cardGroups, cards, namespace, panelId),
  }),
);

export const OtherCardNamespaceConfirmationDialogContainer = connect(
  null,
  mapDispatchToProps,
)(OtherCardNamespaceConfirmationDialog);
